import React, { useEffect } from "react";
import { _goToCategory } from "router/helper";

import { View, TouchableOpacity } from "react-native";

import Img from "component/img";
import Text from "component/typography/Text";

import { colors, sizes } from "asset/constant";
import { css } from "style";
import { routeParamsAtom } from "store";
import { useSetRecoilState } from "recoil";

const width = sizes.screenW / 2 - 15;

export default function CompanyCard(props: { company?: CompanyT }) {
  const { company } = props;
  const setRouteParams = useSetRecoilState(routeParamsAtom);

  const _goToDetails = () => {
    setRouteParams((prev) => ({
      ...prev,
      company_id: company?.id,
      cto: company?.name,
      title: company?.company_name,
      desc: company?.description,
    }));
    _goToCategory();
    // _goToCategory({
    //   id: company?.id,
    //   cto: company?.name,
    //   title: company?.company_name,
    //   desc: company?.description,
    // });
  };

  if (company === undefined) {
    return <View style={{ width, ...css.margins(10) }} />;
  }

  return (
    <TouchableOpacity
      onPress={_goToDetails}
      activeOpacity={sizes.tapOpacity}
      style={[
        {
          width: "100%",
          height: "100%",
          alignItems: "center",
          justifyContent: "space-evenly",
        },
        css.overFlowH,
        css.shadowForWeb(5),
        css.radius(sizes.radius.lg),
        css.bgColor(colors.bg.element),
      ]}
    >
      <>
        <View
          style={[
            css.fix,
            css.width(200),
            css.height(200),
            css.radius(100),
            { right: -90, top: -100 },
            css.border(2, colors.theme + "09"),
          ]}
        />
      </>

      <View
        style={{
          width: "50%",
          aspectRatio: 1,
          overflow: "hidden",
          borderWidth: 1,
          borderColor: colors.border.light + "44",
          borderRadius: sizes.radius.lg,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.bg.lightest,
          // marginBottom: size.space,
        }}
      >
        <Img
          resizeMode="contain"
          style={[
            { width: "100%", aspectRatio: 1 },
            css.border(2, colors.white),
          ]}
          source={{ uri: company?.avatar }}
        />
      </View>
      <View>
        <Text
          style={{ lineHeight: 22 }}
          numberOfLines={1}
          weight="extraBold"
          align="center"
          size={"xxl"}
          color={colors.text.dark}
        >
          {company?.company_name}
        </Text>
        <View style={{ height: 30 }}>
          <Text
            align="center"
            numberOfLines={2}
            style={{ ...css.container }}
            weight="bold"
          >
            {company?.name}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
}
